<template>
  <!-- 文章详情 -->
  <div class="article_details_wap">
    <div class="callwe" @click="linkqq()">联系客服</div>

    <div class="article_details">
      <div class="ad_title">{{ articleDetail.Title }}</div>
      <div class="ad_jj">
        <div>{{ articleDetail._from }}</div>
        <div>{{ articleDetail.Columns? `栏目：${articleDetail.Columns}`: ''}}</div>
        <div>{{ articleDetail.Author? `作者：${articleDetail.Author}`: ''}}</div>
      </div>
      <div class="sfy_wap">
        <div class="sfyjrsq" v-if="articleDetail.is_auth == 3" @click="pushart()">加入授权</div>
        <div class="sfyjrsq2" v-if="articleDetail.is_auth == 1" @click="pushart()">已加入</div>
        <div class="sfyjrsq" v-if="articleDetail.is_auth == 2" @click="pushart()">再次授权</div>

        <div class="sfy_con" @click="followFn">
          <div class="sfy_img sfy_img_two">
            <img v-show="articleDetail.is_follow==2" src="../../assets/zanTrue.png" alt />
            <img v-show="articleDetail.is_follow==1" src="../../assets/zanFalse.png" alt />
          </div>
          <!-- <div class="sfy_txt">{{articleDetail.is_follow==1?"收藏":"取消收藏"}}</div> -->
          <div class="sfy_txt">{{articleDetail.follow_nums?articleDetail.follow_nums:0}}</div>
        </div>
        <div class="sfy_con">
          <el-dropdown>
            <span class="el-dropdown-link" style="display:flex;">
              <div class="sfy_img">
                <img src="../../assets/fx.png" alt />
              </div>
              <div class="sfy_txt">分享</div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="imgflex" @click="shareqq(articleDetail.Title)">
                  <img src="@/assets/qqroom.png" style="width:20px;height:20px;margin-right:10px;" />
                  <div>QQ</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="imgflex" @click="sharewx">
                  <img src="@/assets/we.png" style="width:20px;height:20px;margin-right:10px;" />
                  <div>微信朋友圈</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="wxbox1" v-show="showwxbox">
          <div class="close" @click="closewx()"></div>
          <div>分享到微信朋友圈</div>
          <img :src="shaoma" alt style="width:100%;" />
          <div style="font-size:14px">打开微信，点击底部的“发现”， 使用“扫一扫”即可将网页分享至朋友圈</div>
        </div>
        <div class="sfy_con">
          <div class="sfy_img">
            <img src="../../assets/ll.png" alt />
          </div>
          <div class="sfy_txt">{{articleDetail.read_nums+1 || 0+1}}</div>
        </div>
      </div>
      <div class="details_wap">
        <div
          class="conent-bind"
          v-if="articleDetail.Content"
          v-html="couldReadAllContent ? articleDetail.Content : articleDetail.Content.substr(0, cutSumNumber)"
        ></div>
        <!-- 解锁 -->
        <div class="pay_wap" v-if="!couldReadAllContent && articleDetail.WordSize > cutSumNumber">
          <div>试读结束，如需继续阅读或下载请购买授权套餐解锁剩余内容</div>
          <span>{{`（剩余${articleDetail.WordSize - cutSumNumber}字）`}}</span>
        </div>
      </div>
      <div class="dra_go" v-if="!couldReadAllContent && articleDetail.WordSize > cutSumNumber">
        <!-- <div class="dg_l">
          <div class="dg_l_img">
            <img src="../../assets/dr.png" alt />
          </div>
          <div class="dg_l_txt">转载使用</div>
          <div class="dg_l_txt2">查看转载使用许可协议></div>
        </div>-->
        <router-link to="/informationFlow">
          <div class="dg_r">开通信息流</div>
        </router-link>

        <router-link to="/informationFlow">
          <div class="dg_r">获取文章授权</div>
        </router-link>
      </div>

      <div class="dra_wap">
        <div class="dra_gang"></div>
        <div class="dra_img">
          <img src="@/assets/logos.png" alt />
        </div>
        <div class="dra_rigwap">
          <div>转载使用</div>
          <div><router-link :to="{ path: '/other/licensingLimitations' }">查看转载使用许可协议</router-link></div>
          <div v-if="articleDetail.is_auth == 3" @click="pushart()">加入授权</div>
          <div
            style="background: rgba(179, 179, 179, 1);cursor: pointer;"
            v-if="articleDetail.is_auth == 1"
            @click="pushart()"
          >已加入</div>
          <div v-if="articleDetail.is_auth == 2" @click="pushart()">再次授权</div>
        </div>
      </div>
    </div>
    <div class="list_wap" v-if="this.$store.state.unique_code != ''">
      <div class="tjbookTop_border"></div>
      <div class="tjbook" v-if="userInfo">相关推荐</div>

      <contentList
        :addCallBack="addCallBack"
        :list="recommendList"
        contentWidth="1020px"
        paddingIsShow="false"
      />
    </div>
  </div>
</template>

<script>
import { getToken } from "../../../static/js/util.js";
import contentList from "@/components/common/contentList/index.vue";
import { getArticleDetail, getRecArticle } from "@/api/hb";
import { followArticle } from "@/api/lxc";
import { readingNums, addArticlemth } from "@/api/lyl";
import { mapMutations } from "vuex";

export default {
  name: "article_details",
  data() {
    return {
      showwxbox: false,
      shaoma: "",
      articleDetail: {},
      recommendList: [],
      cutSumNumber: 500
    };
  },
  computed: {
    userInfo() {
      const { userInfo } = this.$store.state;
      return userInfo;
    },
    couldReadAllContent() {
      const { userInfo } = this;
      return (
       userInfo &&
        (parseInt(userInfo.user_type) === 2 ||
          parseInt(userInfo.user_type) === 3 || 
          parseInt(userInfo.auth_type) === 1)
      );
    }
  },
  // state_artlisttype(newVal){
  //     this.recommendList= []
  //     this.getRecArticle(Title)
  //   },
  //   "$store.state.userInfo"(n,o){
  //     this.recommendList= []
  //     this.getRecArticle(Title)

  //   },
  methods: {
    linkqq() {
      let a = "http://wpa.qq.com/msgrd?v=3&uin=1439649533&site=qq&menu=yes";
      window.open(a);
    },
    ...mapMutations(["unique_code"]),
    pushart() {
      if (!getToken("unique_code")) {
        this.$message.warning("登录已过期，请重新登录");
        this.$router.push({ path: "/login" });
        return false;
      } else {
        this.addarticle();
        const { initialState } = this.$route.query;
        this.getArticleDetail(initialState);
      }
    },
    shareqq(a) {
      if (!getToken("unique_code")) {
        this.$message.warning("登录已过期，请重新登录");
        this.$router.push({ path: "/login" });
        return false;
      } else {
        window.open(
          "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
            encodeURIComponent(document.location.href)
        );
      }
    },
    sharewx() {
      if (!getToken("unique_code")) {
        this.$message.warning("登录已过期，请重新登录");
        this.$router.push({ path: "/login" });
        return false;
      } else {
        this.showwxbox = true;
      }
    },
    closewx() {
      this.showwxbox = false;
    },

    async addarticle() {
      try {
        const data = await addArticlemth({
          user_unique_code: getToken("unique_code"),
          title_id: this.articleDetail.TitleID,
          title: this.articleDetail.Title,
          origin: this.articleDetail._from,
          usage_mode: "转载使用",
          admin_code: this.$store.state.userInfo.admin_code
        });
        // console.log(data)
        const { initialState } = this.$route.query;
        this.getArticleDetail(initialState);
        this.$message("授权成功");
      } catch (err) {
        console.log(err);
        this.$message(err.message);
      }
    },

    async followFn() {
      if (this.$store.state.userInfo.unique_code) {
        try {
          const data = await followArticle({
            TitleID: this.articleDetail.TitleID,
            follow_nums: this.articleDetail.follow_nums,
            docid: this.articleDetail.docid,
            uid: this.$store.state.userInfo.unique_code,
            follow_type: Number(this.articleDetail.is_follow) === 1 ? "1" : "2"
          });
          this.articleDetail.is_follow =
            Number(this.articleDetail.is_follow) === 1 ? 2 : 1;
          if (this.articleDetail.is_follow == 1) {
            this.articleDetail.follow_nums = this.articleDetail.follow_nums - 1;
          } else {
            this.articleDetail.follow_nums = this.articleDetail.follow_nums + 1;
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        this.$message.warning("请先登录");
      }
    },
    async getArticleDetail(titleId) {
      try {
        const unique_code = getToken("unique_code");
        const params = {
          TitleID: titleId,
          uid: this.$store.state.userInfo.unique_code,
          p_uid: this.$store.state.userInfo.admin_code
        };
        if (unique_code) {
          params.uid = unique_code;
        }
        console.log;
        const { articleDetail } = await getArticleDetail(params);
        try {
          const data = await readingNums({
            TitleID: articleDetail[0].TitleID,
            uid: this.$store.state.userInfo.unique_code,
            p_uid: this.$store.state.userInfo.admin_code,
            docid: articleDetail[0].docid,
            read_nums: articleDetail[0].read_nums || 0
          });
          // console.log(data);
        } catch (err) {
          console.log(err);
        }
        console.log(articleDetail);
        const [baseData] = articleDetail;
        baseData._from = `来源：${baseData.MagazineName} ${baseData.Year}年第${baseData.Issue}期`;
        this.articleDetail = baseData;
        this.getRecArticle(baseData.Title);
      } catch (error) {
        console.log(error);
      }
    },

    async getRecArticle(Title) {
      try {
        const unique_code = getToken("unique_code");
        if (!unique_code) {
          return;
        }
        const params = {
          Title,
          uid: unique_code,
          p_uid: this.$store.state.userInfo.admin_code
        };
        const { recArticles } = await getRecArticle(params);
        console.log(recArticles);
        this.recommendList = recArticles;
      } catch (error) {
        console.log(error);
      }
    },
    addCallBack() {
      this.getRecArticle(this.articleDetail.Title);
    }
  },
  components: {
    contentList
  },
  created() {
    console.log(this.$store.state.userInfo);
  },
  mounted() {
    this.shaoma =
      "http://qr.topscan.com/api.php?text=" +
      encodeURIComponent(window.location.href);
    const { initialState } = this.$route.query;
    this.getArticleDetail(initialState);
  },
  beforeRouteUpdate(to, from, next) {
    const { initialState } = to.query;
    this.getArticleDetail(initialState);
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped lang="less">
.callwe {
  cursor: pointer;
  width: 20px;
  position: fixed;
  top: 120px;
  right: 0;
  background: #c99f63;
  border-radius: 5px;
  text-align: center;
  color: #fff;
  padding: 5px;
  z-index: 99;
}
.article_details {
  position: relative;
}

.dra_wap {
  display: flex;
  margin-top: 20px;
  .dra_gang {
    width: 4px;
    height: 98px;
    background: #d8d8d8;
  }
  .dra_img {
    margin-left: 20px;
    width: 64px;
    height: 98px;
    img {
      width: 100%;
    }
  }
  .dra_rigwap {
    margin-left: 20px;

    div:nth-of-type(1) {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
    }
    div:nth-of-type(2) {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(64, 125, 248, 1);
      line-height: 22px;
      margin-top: 8px;
      cursor: pointer;
    }
    div:nth-of-type(3) {
      cursor: pointer;
      width: 68px;
      height: 24px;
      background: rgba(21, 47, 106, 1);
      border-radius: 4px;
      width: 68px;
      height: 24px;
      background: rgba(21, 47, 106, 1);
      border-radius: 4px;
      margin-top: 20px;
      line-height: 24px;
      text-align: center;
      color: #fff;
    }
  }
}
.wxbox1 {
  position: fixed;
  z-index: 1000;
  width: 280px;
  // height: 350px;
  left: calc(50% - 140px);
  top: calc(50% - 160px);
  text-align: center;
  border: 1px solid #f0f2f7;
  background-color: #fff;
  padding: 10px;
}
/*.wxbox1{ position: fixed; z-index:1000; width: 280px; height: 350px; left: calc( 50% - 140px ); top : calc( 50% - 160px ); ;text-align:center;    border:1px solid #F0F2F7; background-color: #fff; padding: 10px;}*/
.wxbox1 .close {
  position: absolute;
  z-index: 1001;
  width: 32px;
  height: 32px;
  background: url("../../assets/icon-close.png") center center no-repeat;
  background-size: 14px 14px;
  top: 5px;
  right: 5px;
}
.imgflex {
  display: flex;
  // justify-content: space-between;
  align-items: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.article_details_wap {
  background: #f9f9f9;
  padding: 40px 0;
  box-sizing: border-box;
  .tjbook {
    width: 100%;
    height: 40px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    text-align: left;
    padding: 40px 40px 0 40px;
    margin: 0 auto;
  }
  .list_wap {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 0 0 6px 6px;
    .tjbookTop_border {
      height: 10px;
      background: #f9f9f9;
    }
  }
  .article_details {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 6px 6px 0 0;
    // border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 40px 40px 60px 40px;
    box-sizing: border-box;
    .dra_go {
      width: 400px;
      height: 80px;
      border-radius: 4px;
      margin-top: 20px;
      padding: 40px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin: 0 auto;
      .dg_l_txt2 {
        color: rgba(64, 125, 248, 1);
        cursor: pointer;
      }
      .dg_l {
        width: 50%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .dg_r {
        width: 140px;
        height: 40px;
        background: rgba(21, 47, 106, 1);
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        cursor: pointer;
      }
      .dg_r:hover {
        background: #214da6;
      }
    }
    .ad_title {
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
    }
    .ad_jj {
      font-size: 14px;
      font-weight: 500;
      color: #ababab;
      line-height: 20px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      div {
        width: 30%;
      }
      div:nth-child(2) {
        width: 40%;
        text-align: center;
      }
    }
    .sfy_wap {
      width: 100%;
      margin-top: 18px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .sfyjrsq {
        width: 68px;
        height: 24px;
        background: rgba(21, 47, 106, 1);
        border-radius: 4px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        margin-right: 47px;
        cursor: pointer;
      }
      .sfyjrsq2 {
        cursor: pointer;
        width: 68px;
        height: 24px;
        background: rgba(179, 179, 179, 1);
        border-radius: 4px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        margin-right: 47px;
      }
      .sfy_con {
        //   width: 50px;
        float: left;
        display: flex;
        justify-content: space-between;
        margin-right: 30px;
        cursor: pointer;
        .sfy_img {
          width: 14px;
          height: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          //   background: #000;
          img {
            height: 14px;
          }
        }
        .sfy_txt {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          text-align: left;
          margin-left: 5px;
          line-height: 20px;
        }
      }
      .sfy_con:hover .sfy_txt {
        color: #1966ff;
      }
    }
    .details_wap {
      margin-top: 48px;
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
      text-indent: 2em;
      position: relative;
      .qwe {
        width: 640px;
        height: 340px;
        background: #333;
        margin: 20px auto;
        text-align: center;
        line-height: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        img {
          height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
      .qwe2 {
        width: 500px;
        height: 500px;
        background: #333;
        margin: 20px auto;
        text-align: center;
        line-height: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        img {
          height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
      .qwe3 {
        width: 300px;
        height: 500px;
        background: #333;
        margin: 20px auto;
        text-align: center;
        line-height: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        img {
          height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
      .pay_wap {
        width: 100%;
        height: 100px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.8) 5%,
          rgba(255, 255, 255, 1) 100%
        );
        padding-top: 28px;
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        text-indent: 0;
        div {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          text-align: center;
        }
        span {
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          text-align: center;
          display: block;
          margin-top: 5px;
        }
      }
    }
  }
}
.sfy_img_two {
  margin-right: 8px;
}
.sfy_img_two img {
  height: 30px !important;
}
</style>

<style>
.conent-bind img {
  max-width: 1120px;
  margin-left: -2em;
  margin: 0 auto;
  display: block;
  margin-bottom: 1em;
}
.conent-bind figure img {
  max-width: 100%;
  margin-left: 0;
}
</style>




// WEBPACK FOOTER //
// src/page/article_details/article_details.vue